









































































































































































import Vue from 'vue';
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ColumnType } from '@/components/apiSearch/models/ApiSearch';
import { FilteringModel } from '@/services/filtering';
import IconButton from "@/components/IconButton.vue";
import store, { CurrentAccountStore } from "./services/CurrentAccountStore";
import CurrentAccountArrangement from "./models/CurrentAccountArrangement";
import Tabs from "../../components/Tabs.vue";
import DateInput from "@/components/DateInput.vue";
import MoneyDisplay from '@/components/MoneyDisplay.vue';
import MoneyInput from '@/components/MoneyInput.vue';
import CheckBox from "@/components/CheckBox.vue";
import eventBus from '@/services/eventBus';
import Confirmation from "@/components/Confirmation.vue";
import { ConfirmationMixin } from "@/mixins/confirmation";
import { t } from "@/plugins/i18n";

interface Data {
  filter: FilteringModel;
  items: any[];
  store: CurrentAccountStore;
  comment: string;
  checked: boolean;
  title: string;
  selectedInvoices: any[];
  selectedPartners: any[];
  accDate: string;
  maxValue: number;
}

interface Methods {
  calculateRemaining(oriAmount: number): number;
  addPartnerToSelected(partner: any): void;
  addInvoiceToSelected(invoice: any): void;
  saveArrangement(invoice: CurrentAccountArrangement): void;
  cancelArrangement(): void;
  showDetails(item: CurrentAccountArrangement): void;
  setItems(items: CurrentAccountArrangement[]): void;
}

export default ConfirmationMixin.extend<Data, Methods, {}, {}>({
  components: {
    ApiSearchPage,
    IconButton,
    Tabs,
    DateInput,
    MoneyDisplay,
    MoneyInput,
    CheckBox,
    Confirmation,
  },

    mixins: [ConfirmationMixin],

    data() {
      return {
        filter: new FilteringModel(),
        url: "currentaccount/arrangement",
        items: [],
        store,
        title: t("FolyoszamlaRendezes"),
        comment: "",
        checked: true,
        selectedInvoices: [],
        selectedPartners: [],
        accDate: new Date().toLocaleDateString(),
        maxValue: 0,
      }
    },

    methods: {
      calculateRemaining(oriAmount: number): number{
        return oriAmount - this.selectedInvoices.reduce((a, b) => a + b.amount, 0) - this.selectedPartners.reduce((a, b) => a + b.amount, 0);
      },

      addPartnerToSelected(partner: any){
        if (partner.amount == 0) {
          eventBus.$emit("error", t("CurrentAccount_NemAdottMegOsszeget"))
          return;
        }

        if (partner.amount + this.selectedPartners.reduce((a, b) => (a + b.amount), 0) > this.maxValue) {
          eventBus.$emit("error", t("CurrentAccount_AKivalasztottSzamlakOsszegeMeghaladjaA"))
          return;
        }

        if (partner.isSelected) {
          this.selectedPartners = this.selectedPartners.filter((x) => x.id != partner.id);
        }
        else {
          this.selectedPartners.push(partner);
        }
        partner.isSelected = !partner.isSelected;
        console.log(this.selectedPartners);
      },

      addInvoiceToSelected(invoice: any){
        if (invoice.amount == 0) {
          eventBus.$emit("error", t("CurrentAccount_NemAdottMegOsszeget"))
          return;
        }

        if (invoice.isSelected) {
          this.selectedInvoices = this.selectedInvoices.filter((x) => x.id != invoice.id);
        }
        else {
          if (invoice.amount + this.selectedInvoices.reduce((a, b) => (a + b.amount), 0) > this.maxValue) {
            eventBus.$emit("error", t("CurrentAccount_AKivalasztottSzamlakOsszegeMeghaladjaA"))
            return;
          }
          this.selectedInvoices.push(invoice);
        }
        invoice.isSelected = !invoice.isSelected;
        console.log(this.selectedInvoices);
      },

      async saveArrangement(invoice: CurrentAccountArrangement){
        if (this.selectedInvoices.some(x => x.partner != invoice.partner) || this.selectedPartners.some(x => x.id != invoice.partner)) {
          const confirmed = await this.confirm(t("CurrentAccount_BiztosElteroPartnerreKivanjaAtvezetniAz"));
          if (!confirmed) {
            return;
          }
        }

        if (new Date(this.accDate) < new Date(invoice.accDate)) {
          eventBus.$emit("error", t("CurrentAccount_AKonyvelesDatumaNemLehetKorabbi", [invoice.accDate.toLocaleString().split('T')[0].replaceAll("-", ". ")]));
          return;
        }

        if (this.selectedInvoices.length == 0 && invoice.code != "OVER") {
          const confirmed = await this.confirm(t("CurrentAccount_NemAdottMegCelSzamlaKa"));
          if (!confirmed) {
            return;
          }
        }

        if (this.selectedInvoices.some((x) => this.accDate < x.shipDate)) {
          const confirmed = await this.confirm(t("CurrentAccount_AKivalasztottSzamlakKozottVanOlyan"));
          if (!confirmed) {
            return;
          }
        }

        const ret = await this.store.checkAccDate(invoice.accDate.toString());
        if (ret.code == -1) {
          eventBus.$emit("error", `${ret.err}`);
          return;
        }
        if (ret.code == -2) {
          const confirmed = await this.confirm(`${ret.err}`);
          if (!confirmed) {
            return;
          }
        }

        const payload = {
          invoiceId: invoice.id,
          code: invoice.code,
          accDate: this.accDate,
          comment: this.comment,
          checked: this.checked,
          remaining: this.calculateRemaining(invoice.oriAmount),
          selectedInvoices: this.selectedInvoices,
          selectedPartners: this.selectedPartners
        };
        const res = await this.store.saveArrangement(payload);
        if (res) {
          eventBus.$emit("success", t("CurrentAccount_SikeresRendezes"));
          eventBus.$emit("refreshCurrentAccountArrangement");
          this.cancelArrangement();
        }
        else {
          eventBus.$emit("error", t("CurrentAccount_HibaTortent"));
        }
      },

      cancelArrangement(){
        this.selectedInvoices = [];
        this.selectedPartners = [];
        eventBus.$emit("currentAccountArrangementInvoiceSearch:reload");
      },

      showDetails(item: CurrentAccountArrangement){
        this.items.forEach(x => {
          if (x != item) {
            x.selected = false;
          }
        });

        item.selected = !item.selected;
        this.selectedInvoices = [];
        this.selectedPartners = [];
        this.maxValue = item.oriAmount;
      },

      setItems(items: CurrentAccountArrangement[]) {
        this.items = items;
      },
    },

    computed: {
      columns: () => [
        {
          cell: "selectButton",
          filterable: false,
          width: "80px"
        },
        { 
          field: "id",
          title: "ID",
          width: 80,
        },
        {
          field: "code",
          title: t("Prefix")
        },
        {
          field: "comment",
          title: t("CurrentAccount_BankMegjegyzes"),
        },
        {
          title: t("BelsoID"),
          field: "invoice",
        },
        {
          title: t("Szamlaszam"),
          field: "bgInvNo",
        },
        { 
          field: "partnerName",
          title: t("Partner")
        },
        {
          field: "insDate",
          title: t("LetrehozasDatuma"),
          type: ColumnType.Date
        },
        {
          field: "accDate",
          title: t("KonyvelesDatuma"),
          type: ColumnType.Date
        },
        {
          field: "oriAmount",
          title: t("CurrentAccount_EredetiOsszeg"),
          type: ColumnType.Money,
          cell: "oriAmountTemplate",
          filterable: false,
        },
        {
          field: "currTotal",
          title: t("CurrentAccount_SzamlaTotal"),
          type: ColumnType.Money,
          cell: "currTotalTemplate",
          filterable: false,
        },
        {
          field: "invTotal",
          title: t("CurrentAccount_TotalSzamlaPenznemeben"),
          type: ColumnType.Money,
          cell: "invPaymTotalTemplate",
          filterable: false,
        },
        {
          field: "actionTypeName",
          title: t("CurrentAccount_Akciotipus"),
        },
        {
          field: "accStatusName",
          title: t("KonyvelesiStatusz"),
        },
        {
          field: "invStatusName",
          title: t("SzamlaStatusz"),
        },
      ],
      invoiceColumns: () => [
        {
          cell: "selectButton",
          filterable: false,
          width: "80px"
        },
        { 
          field: "code",
          title: t("Prefix")
        },
        {
          title: t("BelsoID"),
          field: "id",
        },
        {
          title: t("Szamlaszam"),
          field: "bgInvNo",
        },
        { 
          field: "partnerName",
          title: t("Partner")
        },
        {
          field: "total",
          title: t("Brutto"),
          type: ColumnType.Money,
          cell: "totalTemplate",
          filterable: false,
        },
        {
          field: "paid",
          title: t("Fizetve"),
          type: ColumnType.Money,
          cell: "paidTemplate",
          filterable: false,
        },
        {
          field: "amount",
          title: t("Osszeg"),
          cell: "amountTemplate",
          className: "right_text", 
          filterable: false,
        },
        {
          field: "currTotal",
          title: t("Total"),
          type: ColumnType.Money,
          cell: "currTotalTemplate",
          filterable: false,
        },
        {
          field: "invDate",
          title: t("SzamlaDatuma"),
          type: ColumnType.Date
        },
        {
          field: "shipDate",
          title: t("TeljesitesDatuma"),
          type: ColumnType.Date
        },
        {
          field: "statusName",
          title: t("Statusz"),
        },
        { field: "finalRemark", title: t("VegszamlaMegjegyzes"), cell: 'finalRemark', filterable: false, sortable: false },
      ],
      partnerColumns: () => [
        {
          cell: "selectButton",
          filterable: false,
          width: "80px"
        },
        { 
          field: "id",
          title: t("Azonosito")
        },
        {
          field: "name",
          title: t("Nev"),
        },
        // {
        //     field: "nicName",
        //     title: "Rövid név",
        // },
        {
          field: "amount",
          title: t("Osszeg"),
          cell: "amountTemplate",
          className: "right_text", 
          filterable: false,
        },
        { 
          field: "partnerTypeName",
          title: t("PartnerTipus")
        },
        { 
          field: "companyFormName",
          title: t("VallalkozasiForma")
        },
        { 
          field: "taxAccount",
          title: t("Adoszam")
        },
        { 
          field: "invCityName",
          title: t("SzamlazasiCim")
        },
        {
          field: "invAddress",
          title: t("CurrentAccount_PontosSzamlazasiCim"),
        },
        {
          field: "corCityName",
          title: t("LevelezesiCim"),
        },
        {
          field: "corAddress",
          title: t("CurrentAccount_PontosLevelezesiCim"),
        },
        {
          field: "email",
          title: "Email",
        },
        {
          field: "payModeName",
          title: t("FizetesiMod"),
        },
      ],
    },

    beforeDestroy() {
      this.selectedInvoices = [];
      this.selectedPartners = [];
    },
})
